import React from 'react'
import { ChevronLeftIcon,ChevronRightIcon } from '@heroicons/react/outline'
import cx from 'classnames'

export default function ArrowButton({right,onClick}) {
    const classes = cx({
      "z-[1] bg-white rounded-full  arrow top-[40%]  shadow-gray-300 shadow-xl w-7 h-7 ": true,
      "absolute -right-3": right ? true : false,
      "absolute -left-3": right ? false : true,
    });
  return (
    <button type="button" onClick={onClick} className={classes}>
      {right ? (
        <ChevronRightIcon className="w-auto h-auto text-primary " />
      ) : (
        <ChevronLeftIcon className="w-auto h-auto text-primary" />
      )}
    </button>
  );
}
